const firebaseConfig = {
  apiKey: "AIzaSyDKgGvIpEiT37Xh-ssZv5-i-vVK3TVsYb8",
  authDomain: "simlpe-firbase-authintication.firebaseapp.com",
  projectId: "simlpe-firbase-authintication",
  storageBucket: "simlpe-firbase-authintication.appspot.com",
  messagingSenderId: "447456823759",
  appId: "1:447456823759:web:b90e1fc851c03b97502aba",
};

export default firebaseConfig;
